import { render, staticRenderFns } from "./msgPage.vue?vue&type=template&id=6ff48d37&scoped=true"
import script from "./msgPage.vue?vue&type=script&lang=js"
export * from "./msgPage.vue?vue&type=script&lang=js"
import style0 from "./msgPage.vue?vue&type=style&index=0&id=6ff48d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff48d37",
  null
  
)

export default component.exports